import { useEffect, useMemo, useState } from 'react';

import { clientConfig } from '@/config/clientConfig';
import { ApiProfileSimpleResponse, useApi } from '@/shared/api';
import { ApiBaseError } from '@/shared/api/generated/http-client';
import { useApiMyhub } from '@/shared/apiMyhub/useApiMyhub';

type ApiBeneficiary = {
  id: number;
  status: string;
};

type RecordApiBeneficiary = Record<number, ApiBeneficiary>;

// type Response = HttpResponse<ApiProfileResponse[], ApiBaseError>;
type Response = { data: ApiProfileSimpleResponse[] | null; error: ApiBaseError | null };
let promise: Promise<Response> | null = null;

export const useApiBeneficiariesList = () => {
  const api = useApi();
  const apiMyHub = useApiMyhub();

  const [list, setList] = useState<ApiBeneficiary[] | null>(null);
  const [map, setMap] = useState<RecordApiBeneficiary | null>(null);

  const fetchBeneficiaries = useMemo(() => {
    // return api.profilesGetBeneficiaries();
    if (!promise) {
      promise = clientConfig.isExported
        ? apiMyHub.getProfileBeneficiaries()
        : api.profilesGetBeneficiaries();
    }

    return promise;
  }, []);

  useEffect(() => {
    const fetch = async () => {
      const res = await fetchBeneficiaries;

      if (res.data) {
        const record = res.data.reduce<RecordApiBeneficiary>((acc, cur) => {
          acc[cur.id] = cur;
          return acc;
        }, {});

        setList(res.data);
        setMap(record);
      }
    };

    fetch();
  }, []);

  return useMemo(() => {
    return { list, map };
  }, [list, map]);
};
